import React from 'react';
import './Legal.css';

const Legal = () => {
  return (
    <div className="legal-container">
      <h2>Legal Information</h2>
      <p>
        All content on this application, including text, graphics, logos, images, and software, is the property of our company or its content suppliers and is protected by international copyright laws. The compilation of all content on this application is the exclusive property of our company and is protected by international copyright laws.
      </p>
      <h5>Trademarks</h5>
      <p>
        Our trademarks and trade dress may not be used in connection with any product or service that is not ours, in any manner that is likely to cause confusion among customers, or in any manner that disparages or discredits us. All other trademarks not owned by us that appear on this application are the property of their respective owners, who may or may not be affiliated with, connected to, or sponsored by us.
      </p>
      <h5>Disclaimer of Warranties and Limitation of Liability</h5>
      <p>
        This application is provided by us on an "as is" and "as available" basis. We make no representations or warranties of any kind, express or implied, as to the operation of this application or the information, content, materials, or products included on this application. You expressly agree that your use of this application is at your sole risk.
      </p>
      <p>
        To the full extent permissible by applicable law, we disclaim all warranties, express or implied, including, but not limited to, implied warranties of merchantability and fitness for a particular purpose. We do not warrant that this application, its servers, or e-mail sent from us are free of viruses or other harmful components. We will not be liable for any damages of any kind arising from the use of this application, including, but not limited to, direct, indirect, incidental, punitive, and consequential damages.
      </p>
      <h5>Governing Law</h5>
      <p>
        By visiting this application, you agree that the laws of our country, without regard to principles of conflict of laws, will govern these Conditions of Use and any dispute of any sort that might arise between you and us.
      </p>
    </div>
  );
};

export default Legal;